<template>

      <div :ref="'rm_'+index">
        <div @click="selectRegistrationMethod(index)" >
          
        </div>
        <div v-if="selected==index">
          <div v-if="registration_method.registration_method_id==2">
            <div class="row mb-15">
              <input v-model="form.last_name" class="input-text rounded" type="text" placeholder="Last Name" />
            </div>
            <div class="row">
              <input v-model="form.room_number" class="input-text rounded" type="text" placeholder="Room Number" />
            </div>
            <label for="email_consent" class="text-left d-flex align-items-start">
              <input class="mr-10" type="checkbox" name="email_consent" id="email_consent" v-model="form.consent" />
              <span class="text-16">I agree to receive marketing communications from Casa Cody.</span>
            </label>
          </div>
          <div v-if="registration_method.registration_method_id==3">
            <div class="row mb-15 p-rel">
              <input v-model="form.first_name" class="input-text rounded" type="text" placeholder="First Name" />
            </div>
            <div class="row mb-15 p-rel">
              <input v-model="form.last_name" class="input-text rounded" type="text" placeholder="Last Name" />
            </div>
            <div class="row mb-15 p-rel">
              <input v-model="form.email_address" class="input-text rounded" type="text" placeholder="Email" />
            </div>
            <label for="email_consent" class="text-left d-flex align-items-start">
              <input class="mr-10" type="checkbox" name="email_consent" id="email_consent" v-model="form.consent" />
              <span class="text-16">I agree to receive marketing communications from Casa Cody.</span>
            </label>
          </div>
          <div v-if="registration_method.registration_method_id==4" class="row">
            <input v-model="form.access_code" class="input-text rounded" type="text" placeholder="Connect to Wi-Fi" />
          </div>
          <div class="pt-20 mb-15" v-show="show_continue">
            <button @click="emitRegistrationMethodData()" class="btn rounded studio-btn" type="button" :style="'background: ' + color_background_button + '; color: ' + color_text_button">Continue</button>
          </div>
          <p v-show="show_continue" class="text-center make-white text-14 mb-0">By clicking continue you agree to the
            <span @click="selectTermsOfService(index)" class="text-link">Terms and Conditions</span>
          </p>
          <div v-show="show_continue" class="terms-of-service text-left pt-20" v-if="selected_tos==index">
            <div v-html="registration_method.terms_of_service"></div>
            <div class="mt-30 text-center"><button class="btn-close" @click="selectTermsOfService(null)">CLOSE</button></div>
          </div>
        </div>
      </div> <!-- rm -->



</template>
<script>
import Axios from "axios";
export default {
  name: 'registration_method',
  props: ['index','selected','selected_tos','color_background_button','color_text_button','registration_method'],
  data(){
    return{
      // access_code: null,
      // access_code_valid: true,
      // access_code_error_text: 'Required',
      clicked: false,
      form: {
        access_code: '',
        room_number: '',
        first_name: '',
        last_name: '',
        email_address: '',
        consent: false
      },
      // revinate: {
      //   list_token: "",
      //   url: "https://contact-api.inguest.com/api/add-contacts-to-lists",
      // },
    }
  },
  computed: {
    show_continue:function(){
      const email_method_2_ready = this.registration_method.registration_method_id === 2 && this.form.last_name && this.form.room_number;
      const email_method_3_ready = this.registration_method.registration_method_id === 3 && this.form.first_name &&  this.form.last_name && this.form.email_address;
      const email_method_4_ready = this.registration_method.registration_method_id === 4 && this.form.access_code;

      this.$emit('changeButtonState', email_method_2_ready || email_method_3_ready || email_method_4_ready);

      return email_method_2_ready || email_method_3_ready || email_method_4_ready;
    },
  },
  watch: {
    'selected':function(){
      this.$el.querySelector( '#rm_' + this.index ).checked = (this.selected == this.index);
    }
  },
  mounted(){
    this.$el.querySelector( '#rm_' + this.index ).checked = (this.selected == this.index);
  },
  methods: {
    // Generate the description that appears below the Registration Method name
    generateDescription:function(rm){
      if(rm.type!='rateplan') return null;
      var description = '';
      if (parseInt(rm.price)==0) {
        description += 'Connect';
      } else {
        description += '$' + rm.price;
      }

      description += ' for ';

      if(rm.duration>=1440){
        if(rm.duration % 1440 > 0){
          description += ' more than ';
        }
        var whole_days = Math.floor(rm.duration / 1440);
        description += whole_days + ' day'
        if(whole_days > 1){
          description += 's';
        }
      } else if(rm.duration>=60){
        if(rm.duration % 60 > 0){
          description += ' more than ';
        }
        var whole_hours = Math.floor(rm.duration / 60);
        description += whole_hours + ' hour'
        if(whole_hours > 1){
          description += 's';
        }
      } else {
        description += rm.duration + ' minute'
        if(rm.duration > 1){
          description += 's';
        }
      }

      description += ' with ';
      if(rm.additional_devices>0){
        description += 'up to ' + rm.additional_devices + ' devices';
      } else {
        description += '1 device';
      }
      // if(rm.speed_upload && rm.speed_download){
      //   description += ' (' + rm.speed_upload + ' Up / ' + rm.speed_download + ' Down)';
      // }
      return description;
    },
    // Send selected Registration Method back to parent
    selectRegistrationMethod:function(index){
      this.$emit('changeSelected', index);
    },
    // Send selected Terms of Service back to parent
    selectTermsOfService:function(index){
      this.$emit('changeSelectedTOS', index);
    },
    emitRegistrationMethodData: async function(){
      if(this.registration_method.type=='accesscode' && !this.form.access_code){
        this.access_code_valid = false;
        return;
      }
      if(this.clicked) return;
      this.clicked = true;

      const emitted = {
        registration_method_id: this.registration_method.registration_method_id,
        rateplan_id: this.registration_method.id,
        ...(!!this.form.last_name && { last_name: this.form.last_name } ),
        ...(!!this.form.first_name && { first_name: this.form.first_name } ),
        ...(!!this.form.room_number && { room_number: this.form.room_number } ),
        ...(!!this.form.email_address && { email_address: this.form.email_address } ),
        ...(!!this.form.access_code && { access_code: this.form.access_code } ),
        ...(this.form.consent && { email_opt_in: 1 } ),
      }
      this.$emit('emitRegistrationMethodData', emitted);
    },
  }
}
</script>
<style scoped>
.rm .btn { background: #1a1a1a; color: #ffffff; }
</style>
